module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp12_8017.c14a91f1.png";